import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App'
import router from './router'
import { store } from './store.js'
import './assets/scss/app.scss'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import Vuelidate from 'vuelidate'

import Clipboard from 'v-clipboard'

Vue.use(Vuelidate)

//CSV
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import { fas } from '@fortawesome/free-solid-svg-icons'
//import { far } from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' //To use <font-awesome-icon icon="sort-numeric-up" />
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
library.add(faFacebook)
import vueHeadful from 'vue-headful';

//Email editor
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
    hideModules:{
        image:false,
        table:false,
        code:false,
    }
}); // config is optional. more below
import "../node_modules/vue-wysiwyg/dist/vueWysiwyg.css";

  
const fb = require('./firebaseConfig.js')
library.add(faCoffee, fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-headful', vueHeadful);
Vue.use(Clipboard)

Vue.use(BootstrapVue, {

    BFormFile: {
        placeholder: "Please choose a file",
    }
  })

var SocialSharing = require('vue-social-sharing');
 
Vue.use(SocialSharing);
  
Vue.config.productionTip = false

  
// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })

    }
})